import { render } from "./SearchSection.vue?vue&type=template&id=85a4dbfe&scoped=true"
import script from "./SearchSection.vue?vue&type=script&lang=js"
export * from "./SearchSection.vue?vue&type=script&lang=js"

import "./SearchSection.vue?vue&type=style&index=0&id=85a4dbfe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85a4dbfe"]])

export default __exports__